<template>
    <div class="ticket-stack-widget__actions">
        <button
            v-if="canRecreate"
            @click="$listeners.recreate"
            :disabled="isRecreatingTicket"
            class="btn ticket-stack-widget__action-button"
        >
            {{ $t('recreate') | capitalize }}
        </button>
        <button
            @click="$listeners.detailsClick"
            class="btn ticket-stack-widget__action-button"
        >
            {{ $t('details') | capitalize }}
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            canRecreate: {
                type: Boolean,
                required: true,
            },
            isRecreatingTicket: {
                type: Boolean,
                required: true,
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/ticketsWidget/components/TicketFooter.vue